<template>
  <div>
    <router-link to="/" :class="getCrumbClass(-1)" class="crumb">Home</router-link>
    <span v-for="(crumb, index) in crumbs" :key="crumb.name">
      <span class="icon icon-Arrow_Right h5 text-medium crumb-arrow" />
      <router-link :to="getRouterLink(crumb, index)" class="crumb" :class="getCrumbClass(index)">
        {{ crumb.name }}
      </router-link>
    </span>
  </div>
</template>

<style scoped>
.crumb {
  font-weight: 500;
}
.crumb:hover {
  text-decoration: none;
}
.crumb-arrow {
  vertical-align: sub;
}
</style>

<script>
import auth from '@/auth'

export default {
  methods: {
    getRouterLink (crumb, index) {
      if ('to' in crumb) {
        let to = {}
        to.name = crumb.to.name
        if ('params' in crumb.to) {
          to.params = {}
          for (let param of crumb.to.params) {
            to.params[param] = this.$route.params[param]
          }
        }
        return to
      } else if (index + 1 === this.crumbs.length) {
        return this.$route.fullPath
      } else {
        return '/'
      }
    },
    getCrumbClass (index) {
      if (index + 1 === this.crumbs.length) {
        return 'text-dark'
      } else {
        return 'text-medium'
      }
    }
  },
  computed: {
    dumbCrumbs () {
      return this.$route.path.split('/').filter(crumb => crumb)
    },
    crumbs () {
      console.log(this.$route)
      if ('breadcrumbs' in this.$route.meta) {
          let list = []
          let crumbs = this.$route.meta.breadcrumbs

          for(let crumb of crumbs) {
              if (crumb.name.indexOf(':') === 0) {
                  let vname = crumb.name.substring(1)
                  list.push(Object.assign(crumb, { name: this.$route.params[vname] }))
              } else {
                  list.push(crumb)
              }
          }
          return list
      }
      else {
        return []
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/TheBreadcrumbs.vue